const baseUrl = process.env.VUE_APP_BASE_API
// 通用下载方法
export function download(fileName) {
  const a = document.createElement('a')
  a.href = baseUrl +
        '/common/download?fileName=' +
        encodeURI(fileName) +
        '&delete=' +
        true
  a.click()

  // window.location.href =
  //     baseUrl +
  //     '/common/download?fileName=' +
  //     encodeURI(fileName) +
  //     '&delete=' +
  //     true
}
